import { render, staticRenderFns } from "./ResetAllFiltersButton.vue?vue&type=template&id=3b8a30e0&scoped=true&"
import script from "./ResetAllFiltersButton.vue?vue&type=script&lang=js&"
export * from "./ResetAllFiltersButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a30e0",
  null
  
)

export default component.exports